<my-videos-list
  [getVideosObservableFunction]="getVideosObservableFunction"
  [getSyndicationItemsFunction]="getSyndicationItemsFunction"

  [title]="titlePage"

  [defaultSort]="defaultSort"

  [displayFilters]="false"
  [displayModerationBlock]="false"

  [loadUserVideoPreferences]="false"
  [groupByDate]="true"

  [disabled]="disabled"

  [headerActions]="actions"
>
</my-videos-list>
